import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { AnnotationNodeView } from "@/components/editor/nodeviews/AnnotationNodeView";

export const AnnotationBlock = Node.create({
  name: "annotationBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      text: { default: "" },
      originalContent: { default: "" },
      annotationType: { default: "comment" },
      status: { default: "pending" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="annotation-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "annotation-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AnnotationNodeView);
  },
});
